
export const webApiUrl = (window as any).config.WebApiUrl.replace(/\/$/g, "");

export const getImportUrlFromExcel = () => {
    return webApiUrl + "/api/article/excelToArticles";
};
